import { render, staticRenderFns } from "./c_slider.vue?vue&type=template&id=dca57b24&scoped=true"
import script from "./c_slider.vue?vue&type=script&lang=js"
export * from "./c_slider.vue?vue&type=script&lang=js"
import style0 from "./c_slider.vue?vue&type=style&index=0&id=dca57b24&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dca57b24",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dca57b24')) {
      api.createRecord('dca57b24', component.options)
    } else {
      api.reload('dca57b24', component.options)
    }
    module.hot.accept("./c_slider.vue?vue&type=template&id=dca57b24&scoped=true", function () {
      api.rerender('dca57b24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PageDiy/mobileConfigRight/c_slider.vue"
export default component.exports